import styles from './styles.module.scss'

interface LabledInfoProps {
  label: string
  children: React.ReactNode
}

export const LabledInfo = ({ label, children }: LabledInfoProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.label}>{label}</div>
      <div className={styles.content}>{children}</div>
    </div> 
  )
}
